<template>
<div>
  <q-btn
    :icon="homeIcon"
    to="/home"
    flat round dense
    class="q-mx-sm"
    @click="_onClick"
  >
    <q-tooltip>{{ $t('names.home') }}</q-tooltip>
  </q-btn>
</div>
</template>

<script>
import { QBtn, QTooltip } from 'quasar'

export default {
  props: ['homeIcon'],
  components: {
    QBtn, QTooltip
  },
  beforeCreate () {
    this.$store.state.layout.resetHomeTab = false
  },
  methods: {
    _onClick () {
      this.$store.commit('layout/setHomeTab', 'home')
      this.$store.commit('layout/sidebarOpen', true)
    }
  }
}
</script>

<style>
</style>
